import React from 'react';
import { motion } from 'framer-motion';
const capabilities = [{
  title: 'Complex catalogs and configuration',
  body: 'Variants, options, bundles, minimums, and made-to-order products.'
}, {
  title: 'Customer and wholesale pricing',
  body: 'Account pricing, tiered rules, quote-to-order, and repeat purchasing.'
}, {
  title: 'Checkout on your terms',
  body: 'Payment, tax, shipping, account access, and business-specific rules.'
}, {
  title: 'Connected order operations',
  body: 'Inventory, orders, customers, and fulfillment systems working together.'
}];
const feeRows = [{
  party: 'Payment processor',
  detail: 'Standard processing rate'
}, {
  party: 'WebsiteForge',
  detail: 'No percentage of the order'
}, {
  party: 'As online sales grow',
  detail: "WebsiteForge's fee remains 0%"
}];
export function EcommerceFees() {
  return <section id="ecommerce" className="relative overflow-hidden bg-ink py-12 lg:py-16" data-id="element-41" data-mp="1ztv6u8smppdm">
      <div className="absolute inset-0 bp opacity-70" aria-hidden="true" data-id="element-42" data-mp="1sudb9zvfrkkh" />
      <div className="absolute right-0 top-0 h-[26rem] w-[26rem] rounded-full bg-forge-green/[0.08] blur-[130px]" aria-hidden="true" data-id="element-43" data-mp="1swheefligfjp" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-44" data-mp="1j4bp5dmn8c87">
        <div className="grid items-start gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-45" data-mp="1j2795xbgzmrk">
          <div className="min-w-0 lg:col-span-6" data-id="element-46" data-mp="1f2gli2h8pmr9">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.16em] text-forge-green" data-id="element-47" data-mp="1a4et2qxxcb34">
              Custom ecommerce without WebsiteForge transaction fees
            </p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-[1.12] tracking-[-0.02em] text-white sm:text-[2.05rem]" data-id="element-48" data-mp="105pnnxn7sj3r">
              WebsiteForge does not take a percentage of your sales.
            </h2>
            <p className="mt-4 max-w-xl text-[14.5px] leading-relaxed text-mist-200" data-id="element-49" data-mp="2uk0bc2s2p77y">
              WebsiteForge charges 0% transaction fees on the stores we build. Your payment processor still charges its
              standard processing rate, but WebsiteForge does not add a revenue share or per-order platform fee.
            </p>

            <ul className="mt-7 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2" data-id="element-50" data-mp="snreju8y3a12">
              {capabilities.map(c => <li key={c.title} className="min-w-0 border-l-2 border-white/12 pl-4" data-id="element-51" data-mp="esyucii415o5">
                  <p className="text-[14px] font-bold leading-snug text-white" data-id="element-52" data-mp="iuamauogi2zi">{c.title}</p>
                  <p className="mt-1 text-[13px] leading-snug text-mist-300" data-id="element-53" data-mp="16mr20ykq1ivn">{c.body}</p>
                </li>)}
            </ul>
          </div>

          {/* static fee statement */}
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45
        }} className="min-w-0 lg:col-span-6" data-id="element-54" data-mp="xl0084taxw72">
            <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-navy-900/85 shadow-lift" data-id="element-55" data-mp="3nbmtcjbw9rvz">
              <div className="absolute inset-0 bp-fine opacity-70" aria-hidden="true" data-id="element-56" data-mp="3erzzpjas06sm" />

              <div className="relative flex items-baseline gap-5 border-b border-white/10 px-6 py-6 sm:px-7" data-id="element-57" data-mp="3ar7ponu2xxva">
                <p className="font-display text-[3.6rem] font-extrabold leading-none tracking-[-0.03em] text-forge-green sm:text-[4.5rem]" data-id="element-58" data-mp="3or8qy4e9b7ba">
                  0%
                </p>
                <p className="font-display text-[14.5px] font-bold leading-snug text-white" data-id="element-59" data-mp="2w44reexxnl6w">
                  WebsiteForge
                  <br data-id="element-60" data-mp="2r5tj48nadiqs" />
                  transaction fee
                </p>
              </div>

              <ul className="relative divide-y divide-white/[0.08]" data-id="element-61" data-mp="35uhdwcpb5ofo">
                {feeRows.map(row => <li key={row.party} className="flex flex-wrap items-center justify-between gap-2 px-6 py-3.5 sm:px-7" data-id="element-62" data-mp="3103apo4emd0g">
                    <span className="text-[13.5px] font-semibold text-white" data-id="element-63" data-mp="28dijqoruc2xf">{row.party}</span>
                    <span className="text-[13.5px] text-mist-300" data-id="element-64" data-mp="1bm403ndrbsjv">{row.detail}</span>
                  </li>)}
              </ul>

              <p className="relative border-t border-white/10 px-6 py-4 text-[13px] leading-relaxed text-mist-300 sm:px-7" data-id="element-65" data-mp="1gm9v9dj8jx6p">
                No revenue share. No per-order WebsiteForge fee. No penalty for growth.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}